<template>
  <cleaning-services-table></cleaning-services-table>
</template>

<script>
import CleaningServicesTable from '@/components/app/cleaning-services/CleaningServicesTable'

export default {
  name: "CleaningServices",
  components: {
    CleaningServicesTable
  }
}
</script>

<style scoped>

</style>